/* eslint-disable import/prefer-default-export */

export const BannerStatus = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  critical: 'critical',
};
